export default "__VITE_ASSET__MFYraIvj8P3ujAYJ_PSh4w__"